import { render, staticRenderFns } from "./lost-package.vue?vue&type=template&id=14d06151&scoped=true"
import script from "./lost-package.vue?vue&type=script&lang=js"
export * from "./lost-package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d06151",
  null
  
)

export default component.exports